<div class="row">
  <div class="col-12">

    <form id="submitConfirmationCodeForm" [formGroup]="submitConfirmationCodeForm" (ngSubmit)="submitConfirmationCode()">

      <div class="form-group form-label-group">
        <input id="confirmationCodeInput" formControlName="confirmationCodeInput" class="form-control"
               placeholder="Confirmation Code"
               [ngClass]="{ 'is-invalid': submitConfirmationCodeButtonClicked &&
               submitConfirmationCodeForm.controls.confirmationCodeInput.errors }">
        <label for="confirmationCodeInput">Confirmation Code</label>
        <div *ngIf="submitConfirmationCodeButtonClicked && submitConfirmationCodeForm.controls.confirmationCodeInput.errors" class="invalid-feedback">
          <div *ngIf="submitConfirmationCodeForm.controls.confirmationCodeInput.errors.required">Confirmation Code is required.</div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 d-flex">
          <button type="submit" form="submitConfirmationCodeForm"
                  class="btn rounded-pill bg-secondary ml-auto text-white px-5 py-2">
            <span class="font-weight-bold">Submit</span>
          </button>
        </div>
      </div>
    </form>

  </div>
</div>
